import React from "react";
import { useTranslation } from "react-i18next";
import { Basic } from "extranet-component-library";


interface CustomProps {
    claims: Array<any>;
}

const ClaimsTable = ({ claims }: CustomProps) => {
    const { t } = useTranslation();

    return (
        <>
            {claims && claims.length ? (
                <div className="claims-table">
                    <Basic
                        rows={10}
                        items={claims}
                        headers={[
                            { id: "id", label: "ID" },
                            { id: "creationDate", label: t("claim_date") },
                            { id: "state", label: t("headers.status") },
                            { id: "notificationDate", label: t("claim_alert") },
                            { id: "notificationType", label: t("alerts.alert_channel") },
                        ]}
                    />
                </div>
            ) : (
                <div data-testid="no-data" className="no-items">
                    {t("no_items")}
                </div>
            )}
        </>
    );
};

export default ClaimsTable;
